import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import { orderBy as orderByLoadash} from 'lodash';

const initialState = {
  equipmentModels: { count: 0, rows: [] },
  equipmentModel: {},
  equipmentModelsFilter: {},
  loading: false,
  checkDelete: {},
  loadingClone: false,
  loadingChecklistClone: false,
  loadingChecklist: false,
  loadingDocument: false,
};

const setEquipmentModelsFilter = (state, action) => {
  return updateObject(state, {
    equipmentModelsFilter: action.equipmentModelsFilter,
  });
};

const requestEquipmentModelsStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchEquipmentModelsSuccess = (state, action) => {
  return updateObject(state, {
    equipmentModels: action.equipmentModels,
    loading: false
  });
};

const fetchEquipmentModelsByIdSuccess = (state, action) => {
  const equipmentServices = {...action.equipmentModel.equipmentServices};
  const equipmentServiceOrdered = orderByLoadash(equipmentServices, ['serviceType.name'], ['asc']);

  const equipmentModels = {
    ...action.equipmentModel,
    equipmentServices: equipmentServiceOrdered
  }

  return updateObject(state, {
    equipmentModel: equipmentModels,
    loading: false,
    loadingChecklist: false,
    loadingChecklistClone: false,
  });
}

const requestEquipmentModelsFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const deleteEquipmentModelsSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const checkDeleteEquipmentModelsSuccess = (state, action) => {
  return updateObject(state, {
    checkDelete: action.checkDelete,
    loading: false
  });
}

const updateEquipmentServiceInModel = (state, action) => {

  const equipmentModelCopy = { ...state.equipmentModel };
  const index = equipmentModelCopy.equipmentServices.findIndex(service => service._id === action.equipmentService._id)

  if (index < 0) return;
  equipmentModelCopy.equipmentServices[index] = action.equipmentService;

  return updateObject(state, {
    equipmentModel: equipmentModelCopy
  });
}

const updateEquipmentModelsSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const postEquipmentModelsSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const removeServiceEquipmentModelsSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const addServiceEquipmentModelsSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const requestCloneEquipmentModelsStart = (state, action) => {
  return updateObject(state, { loadingClone: true });
};

const requestCloneEquipmentModelsSuccess = (state, action) => {
  return updateObject(state, { loadingClone: false });
};

const requestCloneEquipmentModelsFail = (state, action) => {
  return updateObject(state, { loadingClone: false });
}

const requestCloneEquipmentModelServicesStart = (state, action) => {
  return updateObject(state, { loadingChecklistClone: true });
};

const requestCloneEquipmentModelServicesSuccess = (state, action) => {
  try {
    return updateObject(state, { 
      equipmentModel: action.equipmentModel,
      loadingChecklistClone: false,
     });

  } catch(e) {
    console.log(e);
  }
};

const requestCloneEquipmentModelServicesFail = (state) => {
  return updateObject(state, { loadingChecklistClone: false });
};

export const requestDeleteEquipmentServicesChecklistStart = (state) => {
  return updateObject(state, { loadingChecklist: true });
};
 
export const requestDeleteEquipmentServicesChecklistSuccess = (state, action) => {
   return updateObject(state, {
       loadingChecklist: false,
       equipmentModel: { ...action.equipmentModel, attachments: state.equipmentModel.attachments },
    });
};
 
export const requestDeleteEquipmentServicesChecklistFail = (state) => {
   return updateObject(state, { loadingChecklist: false });
};

// attachment files
const requestAttachmentFileDocumentFail = (state, action) => {
  return updateObject(state, {
    loadingDocument: false
  });
}

const requestAttachmentFileDocumentStart = (state, action) => {
  return updateObject(state, {
    loadingDocument: true
  });
}

const fetchAttachmentFileByIdSuccess = (state, action) => {
  return updateObject(state, {
    attachmentFile: action.attachmentFile,
    loading: false,
    loadingDocument: false
  });
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_EQUIPMENT_MODELS_START: return requestEquipmentModelsStart(state, action);
    case actionTypes.FETCH_EQUIPMENT_MODELS_SUCCESS: return fetchEquipmentModelsSuccess(state, action);
    case actionTypes.FETCH_EQUIPMENT_MODELS_BY_ID_SUCCESS: return fetchEquipmentModelsByIdSuccess(state, action);
    case actionTypes.REQUEST_EQUIPMENT_MODELS_FAIL: return requestEquipmentModelsFail(state, action);
    case actionTypes.DELETE_EQUIPMENT_MODELS_SUCCESS: return deleteEquipmentModelsSuccess(state, action);
    case actionTypes.CHECK_DELETE_EQUIPMENT_MODELS_SUCCESS: return checkDeleteEquipmentModelsSuccess(state, action);
    case actionTypes.UPDATE_EQUIPMENT_MODELS_SUCCESS: return updateEquipmentModelsSuccess(state, action);
    case actionTypes.POST_EQUIPMENT_MODELS_SUCCESS: return postEquipmentModelsSuccess(state, action);
    case actionTypes.REMOVE_SERVICE_EQUIPMENT_MODELS_SUCCESS: return removeServiceEquipmentModelsSuccess(state, action);
    case actionTypes.ADD_SERVICE_EQUIPMENT_MODELS_SUCCESS: return addServiceEquipmentModelsSuccess(state, action);
    case actionTypes.UPDATE_EQUIPMENT_SERVICE_IN_MODEL: return updateEquipmentServiceInModel(state, action);

    case actionTypes.REQUEST_CLONE_EQUIPMENT_MODELS_START: return requestCloneEquipmentModelsStart(state, action);
    case actionTypes.REQUEST_CLONE_EQUIPMENT_MODELS_SUCCESS: return requestCloneEquipmentModelsSuccess(state, action);
    case actionTypes.REQUEST_CLONE_EQUIPMENT_MODELS_FAIL: return requestCloneEquipmentModelsFail(state, action);

    case actionTypes.REQUEST_CLONE_EQUIPMENT_MODEL_SERVICES_START: return requestCloneEquipmentModelServicesStart(state, action);
    case actionTypes.REQUEST_CLONE_EQUIPMENT_MODEL_SERVICES_SUCCESS: return requestCloneEquipmentModelServicesSuccess(state, action);
    case actionTypes.REQUEST_CLONE_EQUIPMENT_MODEL_SERVICES_FAIL: return requestCloneEquipmentModelServicesFail(state, action);
    case actionTypes.SET_EQUIPMENT_MODEL_FILTER: return setEquipmentModelsFilter(state, action);
    case actionTypes.REQUEST_DELETE_EQUIPMENT_SERVICES_CHECKLIST_START: return requestDeleteEquipmentServicesChecklistStart(state, action);
    case actionTypes.REQUEST_DELETE_EQUIPMENT_SERVICES_CHECKLIST_SUCCESS: return requestDeleteEquipmentServicesChecklistSuccess(state, action);
    case actionTypes.REQUEST_DELETE_EQUIPMENT_SERVICES_CHECKLIST_FAIL: return requestDeleteEquipmentServicesChecklistFail(state, action);

    case actionTypes.REQUEST_ATTACHMENTFILE_DOCUMENT_START: return requestAttachmentFileDocumentStart(state, action);
    case actionTypes.REQUEST_ATTACHMENTFILE_DOCUMENT_FAIL: return requestAttachmentFileDocumentFail(state, action);
    case actionTypes.FETCH_ATTACHMENTFILE_BY_ID_SUCCESS: return fetchAttachmentFileByIdSuccess(state, action);
    default: return state;
  }
};



export default reducer;
